import { Outlet } from 'react-router';

export default () => {

    return (<><Outlet /></>)
}